/* =============================================================================
   VIEWS / ADMIN / ARCHIVE-STATE — Geteilter State + Helpers (Session 68 REF-2)
   =============================================================================
   Heraushoisting aus archive.js (S20–S67). Der `_state` wird von allen
   5 Sub-Sektionen (mails, bons, zbons, orders, reservations) gelesen und
   geschrieben, deshalb landet er hier als Single-Source-Modul.

   NICHT-Verantwortlichkeiten:
     - Renderer (in archive.js + archive-{section}.js)
     - Loader (in archive-{section}.js)
     - Public-API-Funktionen wie setArchiveSection (in archive.js)

   Auf direkten Import (`import { _state } ...`) verzichten ist nicht möglich,
   da der State modul-lokal-mutiert wird und Sub-Module ihn lesen+schreiben.
   Das ist der bewährte Pattern aus S66/S67 (orders-modal-state.js etc.).
============================================================================ */

import { dateToISO } from '../../utils/helpers.js';

/** Default-Zeitraum: letzte 30 Tage bis HEUTE. */
export function defaultDateRange() {
  // F9 (S20 Funktionstest): `to` muss HEUTE sein, nicht gestern.
  // Sonst landen heute archivierte Bons / heute bezahlte Bestellungen
  // außerhalb des Default-Filters und tauchen scheinbar nicht im Archiv auf.
  const today = new Date();
  const from = new Date(today);
  from.setDate(today.getDate() - 30);
  // S61 FIX.4: TZ-konsistent (dateToISO) statt UTC-Slice
  return { from: dateToISO(from), to: dateToISO(today) };
}

/** Liest den globalen Storage-State (für reservations/orders-Listen).
 *  Fallback auf leere Listen, wenn storage noch nicht initialisiert. */
export function getState() {
  return (window.App && window.App.storage && window.App.storage._getInternalState())
         || { reservations: [], orders: [] };
}

/** Modul-lokal-persistenter Archive-State. Shared zwischen allen Sub-Sektionen.
 *  Mutiert durch Public-API in archive.js und durch Sub-Modul-Loader. */
export const _state = {
  // S182 Cut 6: Archiv auf zwei Sektionen reduziert (orders + mails). S213-A-HF:
  // Bons-Sektion wieder aufgenommen (Jonas — Personal muss Bons öfter
  // kontrollieren / nachdrucken; „📄 PDF" kommt damit zurück). S237 T1:
  // Z-Bons-Sektion wieder angeschlossen (GoBD-Tagesabschluss-Historie; der
  // Tagesabschluss-Tab zeigt nur den Stichtag). Reservierungen laufen weiter
  // über die zugehörige Bestellung.
  section: 'orders',        // 'orders' | 'mails' | 'bons' | 'zbons'
  search: '',
  status: 'all',            // order: picked_up/cancelled/no_show/all
  dateFrom: '',
  dateTo: '',
  ordersCache: null,        // null = nicht geladen; Array = geladen für aktuellen Bereich
  ordersLoading: false,
  // Bons-Sektion (S213-A-HF: lazy-Refresh beim Tab-Öffnen; Cache lebt im
  // Storage-Adapter, _state hält nur die Lade-Flags).
  bonsLoading: false,
  bonsLoaded: false,
  // Z-Bons-Sektion (S237 T1: gleiches Lazy-Muster wie Bons — Cache lebt im
  // Storage-Adapter (`App.storage.zbonArchive`), _state hält nur die Flags).
  zbonsLoading: false,
  zbonsLoaded: false,
  // Mails-Sektion (S182 Cut 6: unified Liste; S184: KEIN Status-Filter mehr —
  // immer alle Mails, Status nur als Kopfzeile + Spalte)
  mailsCache: null,         // Array | null
  mailsLoading: false,
  mailsUnsub: null          // Realtime-unsubscribe-Funktion
};

// Initial-Range setzen
(function initDateRange() {
  const { from, to } = defaultDateRange();
  _state.dateFrom = from;
  _state.dateTo = to;
})();
